import React from 'react'
import FullWidthCarousel from 'components/Luxkit/Carousel/FullWidthCarousel'
import HostCard from './HostCard'
import Heading from 'components/Luxkit/Typography/Heading'
import BodyText from 'components/Luxkit/Typography/BodyText'
import Group from 'components/utils/Group'
import LayoutContainer from 'components/Common/LayoutContainer'
import MobileHostCarousel from './MobileHostCarousel'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'

interface Props {
  hosts: App.MarketingLeTVHostDetail[]
}

function HostCarousel({ hosts }: Props) {
  return (
    <Group direction="vertical" gap={40}>
      <LayoutContainer size="lg">
        <Group direction="vertical" gap={4}>
          <Heading variant="heading3">Meet the hosts</Heading>
          <BodyText variant="large" colour="neutral-two">Unveiling your ultimate travel companions!</BodyText>
        </Group>
      </LayoutContainer>
      <CSSBreakpoint min="mobile">
        <FullWidthCarousel snap="start">
          {hosts.map((host) => (
            <HostCard
              key={host.image.id}
              name={host.name}
              description={host.description}
              imageId={host.image.id!}
              modalImageId={host.modalImage.id ?? host.image.id}
            />
          ))}
        </FullWidthCarousel>
      </CSSBreakpoint>
      <CSSBreakpoint max="mobile">
        <LayoutContainer size="lg">
          <MobileHostCarousel hosts={hosts} />
        </LayoutContainer>
      </CSSBreakpoint>
    </Group>
  )
}

export default HostCarousel
